module.exports = __webpack_public_path__ + "static/story-3-5e5f9ad6ed5a156b0879ed542ef908bf.png";